"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const EditorState_1 = __importDefault(require("../EditorState"));
const constants_1 = require("../constants");
const change_1 = __importDefault(require("./change"));
function redo(editorState) {
    if (editorState.redoStack.length === 0) {
        return editorState;
    }
    const emptyChange = [];
    let newEditorState = new EditorState_1.default({
        start: editorState.start,
        end: editorState.end,
        list: editorState.list,
        redoStack: editorState.redoStack,
        undoStack: [emptyChange].concat([...editorState.undoStack])
    });
    const [lastChanges, ...rest] = editorState.redoStack;
    newEditorState = lastChanges.reduce((editorState, lastChange) => {
        const updated = change_1.default({
            current: editorState.list,
            change: Object.assign(Object.assign({}, lastChange), { start: lastChange.start - 1, end: lastChange.end - 1 })
        });
        const [lastUndo, ...undoStack] = editorState.undoStack;
        return new EditorState_1.default({
            start: updated.change.start,
            end: updated.change.end,
            list: updated.current,
            redoStack: rest,
            undoStack: [[updated.change].concat(lastUndo || [])].concat(undoStack),
        });
    }, newEditorState);
    return new EditorState_1.default({
        start: newEditorState.start - 1,
        lastChangeType: constants_1.COMMAND.REDO,
        end: newEditorState.end - 1,
        list: newEditorState.list,
        redoStack: newEditorState.redoStack,
        undoStack: newEditorState.undoStack
    });
}
exports.default = redo;
//# sourceMappingURL=redo.js.map